import React from 'react';

const RiskGradeBar = ({ grade, score, label }) => {
  // Define grade ranges and colors (A > 90; B 80-89; C 70-79; D 60-69; F <60)
  const gradeConfig = {
    A: { min: 90, max: 100, color: 'bg-green-500', textColor: 'text-green-700' },
    B: { min: 80, max: 89, color: 'bg-lime-500', textColor: 'text-lime-700' },
    C: { min: 70, max: 79, color: 'bg-yellow-500', textColor: 'text-yellow-700' },
    D: { min: 60, max: 69, color: 'bg-orange-500', textColor: 'text-orange-700' },
    F: { min: 0, max: 59, color: 'bg-red-600', textColor: 'text-red-800' }
  };

  const grades = ['A', 'B', 'C', 'D', 'F'];
  const currentGrade = grade || 'F';
  const currentScore = score || 0;

  return (
    <div className="mb-4">
      {/* Label */}
      <div className="flex items-center justify-between mb-2">
        <span className="font-semibold text-gray-800">{label}:</span>
        <div className="flex items-center space-x-2">
          <span className={`font-bold text-lg ${gradeConfig[currentGrade]?.textColor || 'text-gray-600'}`}>
            {currentGrade}
          </span>
          <span className="text-gray-600 text-sm">
            ({currentScore}/100)
          </span>
        </div>
      </div>

      {/* Grade Bar */}
      <div className="flex space-x-1 h-8 rounded-lg overflow-hidden border border-gray-300">
        {grades.map((gradeLevel) => {
          const config = gradeConfig[gradeLevel];
          const isActive = gradeLevel === currentGrade;
          
          return (
            <div
              key={gradeLevel}
              className={`flex-1 relative transition-all duration-300 ${
                isActive 
                  ? `${config.color} shadow-lg` 
                  : 'bg-gray-200 hover:bg-gray-300'
              }`}
            >
              {/* Grade Letter */}
              <div className={`absolute inset-0 flex items-center justify-center font-bold text-sm ${
                isActive ? 'text-white' : 'text-gray-500'
              }`}>
                {gradeLevel}
              </div>
              
              {/* Active Indicator */}
              {isActive && (
                <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-white"></div>
              )}
            </div>
          );
        })}
      </div>

      {/* Grade Range Labels */}
      <div className="flex justify-between mt-1 text-xs text-gray-500">
        <span>100-90</span>
        <span>89-80</span>
        <span>79-70</span>
        <span>69-60</span>
        <span>59-0</span>
      </div>
    </div>
  );
};

export default RiskGradeBar;